import Vue from "vue";
import Router from "vue-router";
import { isEmpty } from "lodash";

import store from "@app/store";
import SignIn from "@app/components/auth/SignIn";
import ApiRequestsList from "@app/components/admin/api_requests/List";
import ApiRequestShow from "@app/components/admin/api_requests/Show";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      redirect: {
        name: "apiRequestsList"
      }
    },
    {
      path: "/admin/api_requests",
      name: "apiRequestsList",
      component: ApiRequestsList,
      children: [
        {
          path: "/admin/api_requests/:id",
          name: "apiRequestShow",
          component: ApiRequestShow,
          props: true
        }
      ]
    },
    {
      path: "/users/sign_in",
      name: "signin",
      component: SignIn,
      meta: {
        skipAuth: true
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  store.dispatch("setReferrer", from);

  if (!to.meta.skipAuth) {
    initApp();
  }
  next();
});

function initApp() {
  if (isEmpty(store.state.currentUser)) {
    store.dispatch("fetchProfile");
  }
}

export default router;
